<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :width="width + 'px'"
      top="50px"
      @close="onClose"
      :close-on-click-modal="false"
    >
      <div :style="{ height: height + 'px' }">
        <slot name="content"></slot>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="onClose">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    title: { type: String, default: "标题" },
    visible: { type: Boolean, default: false },
    width: { type: Number, default: 600 },
    height: { type: Number, default: 200 },
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    onConfirm() {
      this.$emit("onConfirm");
    },
  },
};
</script>
<style scoped>
::v-deep .el-dialog,
.el-pager li {
  background: rgb(29, 100, 125, 0.6);
}
.el-dialog__wrapper /deep/ .el-dialog {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
}

.el-dialog__wrapper /deep/ .el-dialog__header {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
  padding: 10px 20px 10px;
}

.el-dialog__wrapper /deep/ .el-dialog__title {
  font-size: 1rem;
  color: #ffffff;
  font-weight: 600;
}

.el-dialog__wrapper /deep/ .el-dialog__headerbtn {
  top: 10px;
}

.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 10px 20px;
}

.el-dialog__wrapper /deep/ .el-dialog__close {
  color: #ffffff;
}

.el-dialog__wrapper /deep/ .el-dialog__footer {
  border-top: 1px solid #e8eaec;
  padding: 10px !important;
}

.el-button--primary {
  background: #409eff;
}
</style>
  